import { add, format, isSaturday } from "date-fns";
import { useForm } from "react-hook-form";
import { adminCohortNotAssignedModules, adminGetInstructors } from "../queries";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { myAxios } from "../../../utils/common";
import { toast } from "react-toastify";

type FormValues = {
  planning_date: string;
  topic: string;
  module_id: string;
  instructor_ids: string[];
};

function findNextSaturday() {
  let date = new Date();
  while (!isSaturday(date)) {
    date = add(date, { days: 1 });
  }
  date.setHours(5);
  return date;
}

export default function AssignModuleBox({
  cohortIds,
}: {
  cohortIds: number[];
}) {
  const sorted = cohortIds.sort((a, b) => a - b);
  const {
    register,
    handleSubmit,
    formState: { isValid },
    watch,
    reset
  } = useForm<FormValues>({
    mode: "all",
    defaultValues: {
      topic: "",
      module_id: "",
      instructor_ids: [],
      planning_date: format(findNextSaturday(), "yyyy-MM-dd") + "T05:00",
    },
  });
  const queryClient = useQueryClient();
  const assignModuleMutation = useMutation({
    mutationFn: async (data: { instructor_ids: number[]; module_id: number; cohort_ids: number[]; planning_date: string; }) =>
      myAxios.post("/module_cohort/", data).then((r) => r.data),
    onSuccess: (stuff) => {
      reset();
      queryClient.invalidateQueries({
        queryKey: ["cohortAssignedModules"],
      });
      toast.success("Module eklendi", stuff.id);
    },
  });

  const { topic, module_id } = watch();

  const { data: notAssignedModules } = useQuery(
    adminCohortNotAssignedModules({
      cohort_ids: sorted,
      topic,
    })
  );

  const { data: instructors } = useQuery(adminGetInstructors());


  function handleAssign(data: FormValues) {
    const localDateTime = new Date(data.planning_date);
    const utcDateTime = localDateTime.toISOString();

    const toSend = {
      instructor_ids: data.instructor_ids.map(s => Number(s)),
      module_id: Number(data.module_id),
      cohort_ids: sorted,
      planning_date: utcDateTime
    }

    assignModuleMutation.mutate(toSend);
  }

  return (
    <div className="p-8">
      <div className="p-4 border border-white/20 rounded-xl">
        <h1 className="text-2xl">Yeni ekle</h1>
        <form
          onSubmit={handleSubmit(handleAssign)}
          className="space-y-2 py-4 text-sm"
        >
          <label className="flex items-center">
            <span className="block w-42 p-2">Program</span>
            <select
              {...register("topic", { required: "Seçmek zorunlu" })}
              className="flex-1 border border-white/20 p-2"
            >
              <option value="">Seç..</option>
              <option value="Fullstack Main">Fullstack Main</option>
              <option value="Data Analytics">Data Analytics</option>
            </select>
          </label>

          {topic && (
            <label className="flex items-center">
              <span className="block w-42 p-2">Atanmamış Modüller</span>
              <select
                {...register("module_id", { required: "Seçmek zorunlu" })}
                className="flex-1 border border-white/20 p-2"
              >
                <option value="">Seç..</option>
                {notAssignedModules?.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.order}. {m.name}
                  </option>
                ))}
              </select>
            </label>
          )}

          {topic && module_id && (
            <label className="flex items-center">
              <span className="block w-42 p-2">Eğitmenler</span>
              <select
                multiple
                {...register("instructor_ids", { required: "Seçmek zorunlu" })}
                className="flex-1 border border-white/20 p-2"
              >
                <option value="">Seç..</option>
                {instructors?.map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.username}
                  </option>
                ))}
              </select>
            </label>
          )}

          {topic && module_id && (
            <label className="flex items-center">
              <span className="block w-42 p-2">Tarih</span>
              <input
                className="flex-1 border border-white/20 bg-white/10 p-2"
                {...register("planning_date", { required: "Seçmek zorunlu" })}
                type="datetime-local"
              />
            </label>
          )}

          {topic && module_id && (
            <div className="pl-2">
              <button
                className="bg-myBlue h-10 mt-2 text-sm w-full rounded-lg cursor-pointer font-bold disabled:bg-myBlack disabled:cursor-not-allowed"
                disabled={!isValid}
              >
                MODÜLÜ ATA
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
